import Image from "next/image"
import ImageWithLoader from "../shared/imageWithLoader/ImageWithLoader"
import ShareIcon from "../shared/icons/ShareIcon"
import LatestNews from "./LatestNews"
import { IMediaCenterProps } from "./types"
import { useContext, useRef, useState } from "react"
import { screenSizeContext } from "@/app/store/context/screenSizesContext"
import parse from "html-react-parser"
import ShareToSocial from "../shared/ShareToSocial"
import GeneralSwiper from "../shared/swipers/GeneralSwiper"

const MediaCenterDetails = ({
	data,
	fullData,
	setModalData,
	insideAmenitiesDetailsPage,
	optimizedImage,
}: {
	data: IMediaCenterProps | null
	fullData: IMediaCenterProps[]
	setModalData: (data: IMediaCenterProps | null) => void
	insideAmenitiesDetailsPage?: boolean
	optimizedImage?: boolean
}) => {
	const { isIpad } = useContext(screenSizeContext)

	const formatDate = (dateString?: string) => {
		if (!dateString) return ""
		const date = new Date(dateString)
		return date.toLocaleDateString("en-GB", {
			// day: "2-digit",
			month: "long",
			year: "numeric",
		})
	}

	const sectionRef = useRef<HTMLDivElement>(null)

	const filteredData = fullData.filter((item) => item.id !== data?.id)
	const [showIcons, setShowIcons] = useState(false)

	const mediaList = data?.media || []

	const transformedMedia = mediaList.map((item: any, index: number) => ({
	  src: `${process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL}${item?.media_name}`,
	  type: item?.media_type || "image",
	  alt: `Article Image ${index + 1}`,
	  id: item?.id,
	  videoPoster: item?.poster_desktop  ? `${process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL}${item?.poster_desktop?.media_name}` : ""
	}))

	// Some CMS HTML strings include camelCase attributes like `networkName`.
	// React treats those as unknown props and warns in the console.
	const sanitizedDescriptionHtml =
		data?.description?.en?.replace(/\bnetworkName\s*=/g, "networkname=")

	return (
		<div className="mediaCenter_details" ref={sectionRef}>
			{data?.primary_image_desktop?.media_name &&
				data?.primary_image_mobile?.media_name && (
					<div className={`image_wrapper relative mb-11 h-[26.4rem] `}>
						{optimizedImage ? (
							<ImageWithLoader
								src={
									isIpad
										? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
											data?.primary_image_mobile?.media_name
										: process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
											data?.primary_image_desktop?.media_name
								}
								alt={data.title?.en ?? "Media"}
								sizeVariant="fullWidth"
								quality={75}
							/>
						) : (
							<Image
								src={
									isIpad
										? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
											data?.primary_image_mobile?.media_name
										: process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
											data?.primary_image_desktop?.media_name
								}
								alt={data.title?.en ?? "Media"}
								fill
								className="object-cover"
							/>
						)}
						<div className="label absolute top-2 left-2  bg-white rounded-full px-4 py-2 font-national text-labelM ">
							{data.slug_label}
						</div>
					</div>
				)}
			<div className={`content px-[1.125rem] md:px-8 `}>
				<div className="title font-minerva-regular text-h4 text-oBlack-100 mb-8 leading-[1] ">
					{data?.title?.en}
				</div>
				<div className="flex  flex-col md:flex-row justify-between w-[100%]">
					<div className="date font-national text-labelM text-oBlack-60 mb-8 md:mb-4  flex flex-row md:flex-col justify-between md:justify-start w-[100%] md:w-[30%] ">
						<div className="md:mb-8 lining-nums proportional-nums">
							{formatDate(data?.date)}
						</div>
						<div
							className="share_btn_container"
							onClick={() => {
								setShowIcons(true)
							}}
						>
							<div className="share cursor-pointer">
								<ShareIcon />
							</div>
							<ShareToSocial slug={data?.url_slug} isShow={showIcons} setIsShow={setShowIcons} isArticle />
						</div>
					</div>
					<div className="desc font-national text-bodyM text-oBlack-60 mb-[4rem] w-[100%] md:w-[70%]">
						{sanitizedDescriptionHtml ? parse(sanitizedDescriptionHtml) : null}
					</div>
				</div>
			</div>
			{
				data?.media && data?.media?.length > 0 &&
				<div onClick={(e) => {
					e.stopPropagation();
				}}>

					<GeneralSwiper
						images={transformedMedia}
						slidesPerView={transformedMedia?.length > 1 ? 1.2 : 1}
						isMultiple
						navigationIndex={`article-swiper-${data?.id}`}
						enableFullScreenSwiper
						customImgclass="h-full w-full"
						FullWidth
						swiperClass="!py-0"
						ImgHeight="h-[22rem] lg:h-[42rem]"
						useOuterPopup
						insideAmenitiesDetailsPage={insideAmenitiesDetailsPage}
						optimizedImage={optimizedImage}
					/>
				</div>
			}
			<div className="latest_news">
				<LatestNews
					fullData={filteredData}
					setModalData={setModalData}
					sectionRef={sectionRef}
					label={data?.slug_label}
					insideAmenitiesDetailsPage={insideAmenitiesDetailsPage}
					optimizedImage={optimizedImage}
				/>
			</div>
		</div>
	)
}

export default MediaCenterDetails
